<script lang="ts" setup>
  import Icon from '../Icon/Icon.vue'

  interface IconProps {
    icon?: string
    classes?: string | string[]
    disabled?: boolean
  }

  const props = withDefaults(defineProps<IconProps>(), {
    icon: '',
    classes: '',
    disabled: false,
  })

  const emit = defineEmits<{
    (event: 'clickEvent', payload: boolean): void
  }>()
  const handleClick = () => {
    if (!props.disabled) {
      emit('clickEvent', true)
    }
  }
</script>

<template>
  <div
    :class="[
      {
        'opacity-50 cursor-not-allowed pointer-events-none': props.disabled,
      },
    ]"
    class="flex-shrink-0 cursor-pointer bg-action-black-transparent-subtle-default hover:bg-action-black-transparent-subtle-hover active:bg-action-black-transparent-subtle-active dark:bg-action-white-transparent-subtle-default dark:hover:bg-action-white-transparent-subtle-hover dark:active:bg-action-white-transparent-subtle-active flex items-center justify-center gap-4 rounded-lg p-2"
    data-testid="icon-button"
    @click="handleClick"
  >
    <Icon v-if="icon" :icon="icon" :classes="classes" />
    <slot v-else />
  </div>
</template>
